import { render } from "./WorkingHoursModal.vue?vue&type=template&id=83eb521a&lang=pug"
import script from "./WorkingHoursModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkingHoursModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__